import {
  Box,
  Typography,
  Grid,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

const MissingPage: React.FC = () => (
  <Box m={1}>
    <Grid
      container
      direction="row"
      alignItems="center"
    >
      <Grid item xs={4} />
      <Grid item xs={4}>

        <WarningIcon style={{
          color: 'red',
          fontSize: '12rem',
          textAlign: 'center',
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
        />
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={4} />
      <Grid item xs={4}>
        <Typography align="center" variant="h4">{"Sorry, this page isn't available!"}</Typography>
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={4} />
      <Grid item xs={4}>
        <Typography align="center" variant="body1">
          {'The link you followed may be broken or the page may have been removed.'}
        </Typography>
      </Grid>
      <Grid item xs={4} />
    </Grid>
  </Box>
);

export default MissingPage;
